module.exports = __webpack_public_path__ + "img/1280x720-Night.5ba554a8.jpg";